import styles from "./ForecastResult.module.css";

export default function ForecastResult({
  predictedPrice,
  onBack,
  origin,
  destination,
  truckType,
  startDate,
}) {
  const dims = truckType?.user_dimensions || {};
  const formattedDate = startDate
    ? new Date(startDate).toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
    : "N/A";

  return (
    <div className={styles.resultContainer}>
      <h3 className={styles.title}>Forecast Complete</h3>
      <p className={styles.subtitle}>
        {/* AI-generated forecast based on your selected lane and truck. */}
      </p>

      <div className={styles.laneDetails}>
        <div>
          <strong>Lane:</strong> {origin?.label || origin?.full || "—"} →{" "}
          {destination?.label || destination?.full || "—"}
        </div>
        <div>
          <strong>Truck:</strong> {truckType.raw_truck_name || "—"} (
          {dims.capacity_mt || "?"}MT, {dims.length_ft || "?"}ft,{" "}
          {dims.body_type || "?"}, {dims.axle_type || "?"})
        </div>
        <div>
          <strong>Date:</strong> {formattedDate}
        </div>
      </div>

      <div className={styles.priceBox}>
        <span className={styles.priceValue}>
          ₹ {Number(predictedPrice).toLocaleString("en-IN")}
        </span>
        <span className={styles.priceLabel}>/ trip</span>
      </div>

      <div className={styles.note}>
        <p>
          This is an indicative price estimated by Lorri AI using historical
          freight rates, fuel trends, and lane analysis.
        </p>
        <p>
          The price assumes the current average diesel cost per litre. Real-time
          rates may vary due to market, seasonal, and negotiation-based factors.
        </p>
      </div>

      <div className={styles.buttonRow}>
        <button className={styles.backBtn} onClick={onBack}>
          Try Another Lane
        </button>
      </div>
    </div>
  );
}
